import { Box, Grid } from "@mui/material";
import SearchableList, { TSearchableItem } from "components/SearchableList";
import { useState } from "react";
import { useFormContext } from "react-hook-form";

interface OptionSet {
  [key: string]: {
    id: string;
    label: string;
    options: TSearchableItem[];
  };
}

interface CategorisedNumberEntries {
  category_id: string;
  health_info_id: number;
}

const HealthConditionsTab = (props: { healthOptionsSets: OptionSet }) => {
  const { healthOptionsSets } = props;
  const formContext = useFormContext();
  const { setValue, getValues } = formContext;
  const [selectedValues, setSelectedValues] = useState<CategorisedNumberEntries[]>([
    ...getValues("health_conditions"),
  ]);

  //#region event handlers
  const handleUpdateInterests = (v: number[], categoryId) => {
    let healthConditions: CategorisedNumberEntries[] = [...getValues("health_conditions")];
    //Delete all entries following categoryId
    let indexesToDelete: number[] = [];
    healthConditions.forEach((e, i) => {
      if (e.category_id === categoryId) indexesToDelete.push(i);
    });
    for (let i = indexesToDelete.length - 1; i >= 0; i--) {
      healthConditions.splice(indexesToDelete[i], 1);
    }
    //Add the fresh batch of numbers
    v.forEach((e) => healthConditions.push({ category_id: categoryId, health_info_id: e }));
    setValue("health_conditions", [...healthConditions]);
    setSelectedValues([...healthConditions]);
  };
  //#endregion event handlers

  const countSelectedItems = (key) => {
    return selectedValues.filter((val) => val.category_id === key).length;
  };

  return (
    <Grid container spacing={6} pr="10px" className="member-form-interests-tab">
      {healthOptionsSets &&
        Object.keys(healthOptionsSets).map((e, index) => {
          if (healthOptionsSets[e].id === "EXERCISE_READINESS") return null;
          const preselectedValues = selectedValues
            ?.filter((f) => f.category_id === healthOptionsSets[e].id)
            .map((m) => m.health_info_id);
          return (
            <Grid item xs={6} key={new Date().getTime() + `_${index}`}>
              <Box mb={`20px`}>
                <h2>{healthOptionsSets[e].label}</h2>
              </Box>
              <SearchableList
                className="base-list"
                options={healthOptionsSets[e].options}
                callback={(v) => handleUpdateInterests(v, healthOptionsSets[e].id)}
                preselectedValues={preselectedValues}
              />
              <span className="selectedGoalsSummary">{countSelectedItems(e)} items selected</span>
            </Grid>
          );
        })}
    </Grid>
  );
};

export default HealthConditionsTab;
